import { render, staticRenderFns } from "./cadferiados.vue?vue&type=template&id=004c003b&"
import script from "./cadferiados.vue?vue&type=script&lang=js&"
export * from "./cadferiados.vue?vue&type=script&lang=js&"
import style0 from "./cadferiados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports